/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 14:45:16
 * @LastEditors: 诺
 * @LastEditTime: 2022-04-25 20:23:33
 * @Description: file content
 */
import qs from "qs";
import myAxios from "./interceptors"
import sign from '@/utils/sign'
let axios = new myAxios();
const saleHost = process.env.VUE_APP_API;
const host = process.env.VUE_APP_BASEAPI;
// Add a request interceptor
axios.axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  // console.log("http interceptors by common");
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});
export default {
  qs: qs,
  get(url, param, header) {
    const Sign = new sign
    header = {
      ...header,
      timestamp: Sign.timestamp,
      actSignKey: Sign.signKey,
      actSign: Sign.paySign('/' + url.split(host)[1]),
      version: Sign.version
    }
    return new Promise((resolve, reject) => {
      axios.axios({
        method: "get",
        url,
        params: param,
        headers: {
          ...header,
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  post(url, param) {
    return new Promise((resolve, reject) => {
      const Sign = new sign
      let header = {
        timestamp: Sign.timestamp,
        actSignKey: Sign.signKey,
        actSign: Sign.paySign('/' + url.split(host)[1]),
        version: Sign.version
      }
      axios.axios({
        method: "post",
        url,
        // params: param,
        data: param,
        headers: {
          ...header,
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
